<template>
  <div class="card-box" :style="{background: bg}">
    <div class="card-box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardBox',
  props: {
    bg: {
      type: String,
      default: '#F9FAFB'
    }
  },
}

</script>

<style scoped lang="less">
.card-box {
  display: flex;
  justify-content: center; /* 居中 */
  padding: 0 10px;
}

.card-box-content {
  width: 1600px;

  @media (max-width: 768px) {
    width: 100%;
  }
}
</style>
